export default "__VITE_ASSET__BKlqBDFb__"